import { render, staticRenderFns } from "./add-import.vue?vue&type=template&id=f095db10&scoped=true&"
import script from "./add-import.vue?vue&type=script&lang=js&"
export * from "./add-import.vue?vue&type=script&lang=js&"
import style0 from "./add-import.vue?vue&type=style&index=0&id=f095db10&prod&lang=css&"
import style1 from "./add-import.vue?vue&type=style&index=1&id=f095db10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f095db10",
  null
  
)

export default component.exports